import { Link } from 'react-router-dom';

import styled, { css } from 'styled-components';

import media from '../../../theme/media';

// Default variant - tertiary
const getBackground = (props) => {
    switch (props.variant) {
        case 'primary':
            return props.disabled ? props.theme.purple_24_tr : props.theme.purple_100;
        case 'secondary':
            return props.$isInverted ? props.theme.white_24_tr_base : props.theme.white;
        case 'tertiary':
            return props.theme.white;
        case 'tertiary_light':
            return 'transparent';
        case 'error':
            return props.theme.pink_8_tr;
        case 'errorHint':
            return props.theme.white;
        default:
            return props.theme.white;
    }
};

const getHoverBackground = (props) => {
    switch (props.variant) {
        case 'primary':
            return props.disabled ? props.theme.purple_24_tr : props.theme.purple_72_lc;
        case 'secondary':
            return props.$isInverted ? props.theme.white_40_tr_base : props.theme.purple_8_tr;
        case 'tertiary':
            return props.theme.grey_16_lc;
        case 'tertiary_light':
            return props.theme.white;
        case 'error':
            return props.theme.pink_16_tr;
        case 'errorHint':
            return props.theme.pink_8_tr;
        default:
            return props.theme.grey_16_lc;
    }
};

const getActiveBackground = (props) => {
    switch (props.variant) {
        case 'primary':
            return props.disabled ? props.theme.purple_24_tr : props.theme.purple_72_lc;
        case 'secondary':
            return props.$isInverted ? props.theme.white_40_tr_base : props.theme.purple_8_tr;
        case 'tertiary':
            return props.theme.grey_8_lc;
        case 'tertiary_light':
            return props.theme.white;
        case 'error':
            return props.theme.pink_16_tr;
        case 'errorHint':
            return props.theme.pink_8_tr;
        default:
            return props.theme.grey_8_lc;
    }
};

const getBoxShadow = (props) => {
    const raised = props.raised && props.raised.toString() === 'true' && !props.disabled;
    if (props.variant === 'primary') {
        return raised ? `0px 8px 8px ${props.theme.purple_16_tr}` : 'none';
    }
    return raised ? `${props.theme.shadow_grey}` : 'none';
};

const getSize = (props) => {
    switch (props.size) {
        case 'small':
            return '28px';
        case 'tight':
            return '40px';
        case 'fit':
            return '56px';
        default:
            return '40px';
    }
};

const getDesktopSize = (props) => {
    switch (props.size) {
        case 'small':
            return '32px';
        case 'tight':
            return '56px';
        case 'fit':
            return '112px';
        default:
            return '56px';
    }
};

const CommonCss = css`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => getBackground(props)};
    border: none;
    border-radius: 50%;
    width: ${(props) => getSize(props)};
    height: ${(props) => getSize(props)};
    padding: 0;
    box-shadow: ${(props) => getBoxShadow(props)};
    pointer-events: auto;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    margin-right: ${(props) => (props.$marginRight ? props.$marginRight : null)};
    margin-top: ${(props) => (props.$marginTop ? props.$marginTop : null)};

    &:hover {
        background-color: ${(props) => getHoverBackground(props)};
    }

    &:active {
        background-color: ${(props) => getActiveBackground(props)};
    }

    &:focus {
        background-color: ${(props) => getActiveBackground(props)};
    }

    &:focus-visible {
        outline: 1px dashed ${(props) => props.theme.purple_24_lc};
    }

    ${media.desktop1920} {
        width: ${(props) => getDesktopSize(props)};
        height: ${(props) => getDesktopSize(props)};
    }
`;

export const CommonButton = styled.button`
    ${CommonCss};
`;
export const LinkButton = styled.a`
    ${CommonCss};
`;
export const ReactLinkButton = styled(Link)`
    ${CommonCss};
`;
